var exports = {
  "aW": "connected__Bcnen7",
  "Ub": "pending__xmZIM7",
  "z3": "error__b61J1R",
  "L5": "unknown__E6nv2r",
};

module.exports = exports;
